import React from 'react'
import Container from '../../../bootstrap/component/Container'
import Input from '../../../form/component/Input'
import Password from '../../../form/component/Password'
import { ERROR_PASSWORD_MUST_BE_NEW, ERROR_PASSWORD_NOT_IDENTICAL, ERROR_PASSWORD_NOT_SECURE } from '../../state/auth/const'

const LoginForm = ({ login, error, loginData, changeLoginData, isPasswordResetRequired }) => {
    if (isPasswordResetRequired) {
        return null
    }
    return (
        <form onSubmit={login} target="iframe" action="/api/security/dummy-endpoint" method="POST">
            <div className="login-box-inner">
                <Input name="email" object={loginData} onChange={changeLoginData} placeholder="Email"/>
                <Password name="password" object={loginData} onChange={changeLoginData} placeholder="Password"/>

                {error && <div className="login-error">Email/Password is wrong</div>}
                <button className="btn btn-primary col-xs-12">Login</button>
            </div>
            <iframe name="iframe" id="iframe" style={{ display: 'none' }} title="login-iframe"/>
        </form>
    )
}

const PasswordResetForm = ({ changePassword, error, loginData, changeLoginData, isPasswordResetRequired }) => {
    if (!isPasswordResetRequired) {
        return null
    }
    return (
        <form onSubmit={changePassword} target="iframe" action="/api/security/dummy-endpoint" method="POST">
            <div className="login-box-inner" style={{ height: '420px' }}>
                Please set a new password
                <Input name="email" object={loginData} onChange={changeLoginData} placeholder="Email"/>
                <Password name="password" object={loginData} onChange={changeLoginData} placeholder="old Password"/>
                <Password name="newPassword" object={loginData} onChange={changeLoginData} placeholder="new Password"/>
                <Password name="newPasswordRepeat" object={loginData} onChange={changeLoginData} placeholder="repeat new Password"/>

                {error === ERROR_PASSWORD_NOT_SECURE && <div className="login-error">Password needs 10 digits, capital & lowercase, number, and special characted</div>}
                {error === ERROR_PASSWORD_NOT_IDENTICAL && <div className="login-error">Passwords are not identical</div>}
                {error === ERROR_PASSWORD_MUST_BE_NEW && <div className="login-error">You need to set a new password</div>}

                <button className="btn btn-primary col-xs-12">Login</button>
            </div>
            <iframe name="iframe" id="iframe" style={{ display: 'none' }} title="login-iframe"/>
        </form>
    )
}


const Login = ({ loginData, changePassword, changeLoginData, login, error, isPasswordResetRequired }) => {
    return (
        <div className="login-full-wrapper">
            <Container>
                <div className="login-box">
                    <div className="login-header">
                        <img src="/asset/image/logo-white.svg" alt="Logo" width={200}/>
                    </div>
                    <LoginForm
                        changeLoginData={changeLoginData}
                        login={login}
                        error={error}
                        isPasswordResetRequired={isPasswordResetRequired}
                        loginData={loginData}/>
                    <PasswordResetForm
                        changeLoginData={changeLoginData}
                        changePassword={changePassword}
                        error={error}
                        isPasswordResetRequired={isPasswordResetRequired}
                        loginData={loginData}/>
                </div>
            </Container>
        </div>
    )
}


export default Login



// WEBPACK FOOTER //
// ./src/modules/security/component/auth/Login.js